import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Autocomplete } from "@similarweb/ui-components";

export const StyledItemsContainer = styled.div`
    max-height: 404px;
    overflow-y: auto;
    margin-right: 2px;
    border-radius: 18px;
    padding: 8px 0;

    &::-webkit-scrollbar {
        width: 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${colorsPalettes.carbon[200]};
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: ${colorsPalettes.carbon[0]};
        margin: 12px 0;
    }
`;

export const StyledCompanyAutocomplete = styled(Autocomplete)<{
    isFocused: boolean;
    hasSuperAgentButton: boolean;
    isQuotaRenderedInInput: boolean;
}>`
    width: 100%;
    height: 48px;

    .AutoCompleteContainer {
        transform: none;
        padding: 0;
        background: transparent;
        border-radius: 50px;
        border: 1px solid transparent;
        box-shadow: none;
        height: 48px;
    }

    .input-container {
        border-radius: 50px;
        height: 48px;
        border: 1px solid ${colorsPalettes.midnight[50]};

        input {
            padding: 12px 36px 12px 0;
            padding-right: ${({ hasSuperAgentButton, isQuotaRenderedInInput }) => {
                let padding = 36;
                if (hasSuperAgentButton) {
                    padding += 115;
                }
                if (isQuotaRenderedInInput) {
                    padding += 170;
                }
                return `${padding}px`;
            }};
        }
    }

    .ListItemsContainer {
        position: relative;
        border-radius: 20px !important;
        transform: translate(0, 10px);
        z-index: 1;
        border: 1px solid ${colorsPalettes.carbon[100]};
        box-shadow: 0px 3px 5px 0px #2a3e521f;

        &::before {
            display: none;
        }
    }

    ${({ isFocused }) =>
        isFocused &&
        css`
            .input-container {
                border: 1px solid ${colorsPalettes.blue[400]};
                box-shadow: 0px 3px 5px 0px #2a3e521f;
            }
        `}
`;

export const StyledAIItem = styled.div`
    padding: 10px 16px;
    display: flex;
    gap: 8px;
    align-items: center;
    &:hover {
        background: ${colorsPalettes.carbon[50]};
        cursor: pointer;
    }
`;
